import { render, staticRenderFns } from "./DialogHeaderFlagMenu.vue?vue&type=template&id=aad127a2"
import script from "./DialogHeaderFlagMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogHeaderFlagMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports